export default "__VITE_ASSET__BH$JsecH__"